<style lang="stylus"></style>

<template>
    <div class="user-mo-waterfall">
        <div class="user-mo-waterfall--grid-sizer"></div>
        <div class="user-mo-waterfall--gutter-sizer"></div>
        <Work v-for="work in works" :work="work" :workType="workType" :key="work.id" />
    </div>
</template>

<script>
    import "./style/tplWaterfall.styl";
    import Work from "./work.vue";
    export default {
        name: "tplWaterFall",
        components: { Work },
        props: ["works", "workType"],
        data() {
            return {};
        },
    };
</script>
